import React from 'react'
import qs from 'query-string'

import {Credential} from 'common'

import {
    Window, Parallax, LinkToRoot, PhoneHint,
    PasswordHint, Form, Input, AuthPage
} from 'common/components'


export default class SecretEdit extends AuthPage {
    config = {
        namespace: 'confirm',
        url: 'api/users/password/recovery/confirm',
        typeOf: 'password',

        sanitize: (data) => ({
            ...data,
            login: {
                login: this.login(),
                loginType: Credential.typeOf(this.login())
            }
        }),

        method: 'POST',
        redirect: '/'
    }

    login = () => (this.props.match.params.login)
    heading = ['ВІДНОВЛЕННЯ ПАРОЛЯ', '']


    render() {
        const {location = {}} = this.props
        const params = qs.parse(location.search)
        const {token} = params

        return (
            <Window message={this.heading} picture='password'>
                <Form
                    label='Зберегти новий пароль'
                    onSubmit={this.onSubmit}
                    csrf
                >
                    <Input
                        name='password'
                        type='password'
                        title='Пароль'
                        validations='isSecure'
                        hint={() => <PasswordHint />}
                    />

                    <Input
                        name='token'
                        value={token}
                        type='hidden'
                    />
                </Form>

                <LinkToRoot />
            </Window>
        )
    }
}
